export default __webpack_public_path__ + "static/media/ic-arrow-down-colored.8c9d7903.svg";